import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { gatekeyService } from '../../service/gatekey.service';
import { userService } from '../../service/user.service';
import { FormGroup,FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { commonService } from '../../service/common.service';

import { sessionService } from '../../service/session.service';
import { HttpErrorResponse } from '@angular/common/http';




@Component({
  selector: 'app-challenge-forum',
  templateUrl: './challenge-forum.component.html',
  styleUrls: ['./challenge-forum.component.css'],
  providers:[gatekeyService,userService]
})
export class ChallengeForumComponent implements OnInit {
  challengeForm:any;
  userId:any;
  gateId:any;
  msg:string;
  isError=false;
  user:any;
  gateval:any;
  sectionarry:any=[];
  questionarry:any=[];
  quescount:any;
  uploadimageId:any;
  arrayimage:any=[];
  objItemArray:any;
  @Input() fileExt: string = "PDF";
  msgclass="success";//danger
  submiterror=false;
  isclickbuttonsubmit=false;
  Challenge={'title':'Challenge Form','desciprtion':'desciprtion'};

  constructor(private global:Globals,private _fb: FormBuilder,private _user:userService,private router:Router,private route: ActivatedRoute,private _gatekey:gatekeyService) {

    this.challengeForm=FormGroup;
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
   }

   /****for file upload****/
  readonly rootUrl = this.global.siteUrl;
  url =this.rootUrl+'file/upload?folder='+this.global.gatekeyFolder;
  path=this.global.gatekeyUrl;
  errors: Array<string> =[];
  fileExtExists=false;
  uploader:FileUploader=new FileUploader({url:this.url,authToken:localStorage.getItem('_to'),allowedFileType: ["pdf"]});
  attactmentlist:any=[];
  getimagesArry:any;
  newimageidArry=[];
  massege='Image Extention not Valid allow extension is (pdf)';
  public hasBaseDropZoneOver:boolean = false;
  public hasAnotherDropZoneOver:boolean = false;
  public origin: any;
  public destination: any;
  pathurl:any;
  selectedFile=null;
  rowindex:number;
  showitemrows=true;

  gatekeyarry:any;

 
  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }
 
  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });
   }
 
  
  /****for file upload**this.initItemRows()**[new FormControl('')*/

  ngOnInit() {
    this.challengeForm = this._fb.group({
      itemRows: this._fb.array([this.initItemRows()])
    });
    this.route.queryParams.subscribe(params => { 
      if(params['searchparam']){

        let searchArry:any;
              let resultpar={}
              searchArry=decodeURIComponent(atob(params['searchparam'])).split('&').forEach(function(part,index) {
                 var item = part.split('=');
                 resultpar[index] = item;
              });
              this.gateId = resultpar[0][1];
              this.userId=resultpar[1][1];
              
              if(this.gateId && this.userId){
              this._gatekey.editgatekeydetails(this.gateId,this.userId).subscribe((data : any)=>{
                if(data.error==0){
                  this.gateval={
                    stream:data.results.stream.streamName,
                    paperName:data.results.paperName,
                    streamId:data.results.streamId,
                  }
                  this._gatekey.editgatekeyitemdetails(data.results.id).subscribe((dataitem : any)=>{
                      if(dataitem.error==0){
                        //console.log(data.results);
                       // console.log('set items');
                       // console.log(dataitem.results.rows);
                        this.sectionarry=dataitem.results.rows;
                      }
                      
                  })
                   
                }
                else{
                  this.showitemrows=false;
                  this.submiterror=true;
                  this.msgclass="danger";
                  this.msg=data.message;
                }
      
              });
             }
             this._user.editgetuser(this.userId).subscribe((data : any)=>{
              if(data.error==0){ 
                 // load session drop box
                 
                let dobArray = data.results.dob.split("-");
                this.user = {
                  Status:((data.results.status==1)?"Active":"Inactive"),
                  Fname:data.results.firstName,
                  Lname:data.results.lastName,
                  Email:data.results.email,
                  Cnumber:data.results.mobile,
                  Center: data.results.centerId.split(',').map(Number),
                  Gender:((data.results.gender=="M")?"Male":"Female"),
                  UserType:data.results.userType,
                  Dob:{"year":parseInt(dobArray[0]),"month":parseInt(dobArray[1]),"day":parseInt(dobArray[2])}
                   }
                }else{
                if(data.message=="Failed to authenticate token."){
                  this.router.navigate(['/admin']);
                }else{
                this.msg = data.message;
                this.isError = true;
                }
              }

            });
            }
      });
  }
  private sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  onFileChanged(event,objarry,index) {
    const control = <FormArray>this.challengeForm.controls['itemRows'];
    for(let i = control.length-1; i >= 0; i--) {
      control.value[i].rowindex=null;
    }
    
    this.objItemArray=objarry;
    this.rowindex=index;
    if(event.target.files!=''){
      //console.log('filechangeEXT');
      this.selectedFile = event.target.files
      this.isValidFileExtension(this.selectedFile);

      if(this.fileExtExists==false){
        this.uploader.queue[0].upload();
        
        }
        else{
          this.uploader.queue=[];
        }
    

    }
    //console.log('gdfs');
    //console.log(this.arrayimage);
    
  }


  private isValidFileExtension(files){
    // Make array of file extensions
     var extensions = (this.fileExt.split(','))
                   .map(function (x) { return x.toLocaleUpperCase().trim() });
                   //.log(extensions+'test');
  //  // Get file extension
        var ext = files[0].name.toUpperCase().split('.').pop() || files[0].name;
        //console.log(ext+'test321');
        // Check the extension exists
        var exists = extensions.includes(ext);
        if(!exists){
            this.fileExtExists=true;
        }
        else{
          this.fileExtExists=false;
        }
      
    
  }

  patch() {
    // the formarray
    const control = <FormArray>this.challengeForm.controls['itemRows'];
    // iterate your object and pushes new values
    //this.edititemarry.forEach(x => {
      control.push(this.patchValues('select', 'select'))
    //})
  }
  // assign the values
patchValues(value1,value2) {
  return this._fb.group({
    rowindex:'',
  })    
}

    /*
          This creates a new formgroup. You can think of it as adding an empty object
          into an array. So we are pushing an object to the formarray 'itemrows' that
          has the property 'itemname'. 
          */
initItemRows() {
          return this._fb.group({
            section:['',[Validators.required]],
            question:['',[Validators.required]],
            studentAns:['',[Validators.required]],
            studentExpln:['',[Validators.required]],
            fileName:['']
          });
}
     

      addNewRow() {
          const control = <FormArray>this.challengeForm.controls['itemRows'];
          control.push(this.initItemRows());
      }

      deleteRow(index: number) {
          const control = <FormArray>this.challengeForm.controls['itemRows'];
          control.removeAt(index);
      }

  register(formval){
    this.isclickbuttonsubmit=true;
    var uploadedimagesid:any=[];
    formval.value.userId=this.userId;
    formval.value.gateId=this.gateId;
    formval.value.streamId=this.gateval.streamId
    if(formval.status=="INVALID"){
      this.submiterror=true;
      this.msgclass="danger";
      this.msg="Please fill all required fields.";
      return false;
    }else{
      this.submiterror=false;
    this._gatekey.addchallenge(formval.value).subscribe((data : any)=>{
      if(data.error==0){
        this.showitemrows=false;
        this.isclickbuttonsubmit=false;
        this.challengeForm = this._fb.group({
          itemRows: this._fb.array([this.initItemRows()])
        });
        this.submiterror=true;
        this.msgclass="success";
        this.msg=data.message;
      }
      else{
        this.showitemrows=false;
        this.submiterror=true;
        this.msgclass="danger";
        this.msg=data.message;
      }
    })
   }
  }

  onChangeSection(event,sectionval){
    this.questionarry=[];
     
     for(var i in this.sectionarry){
       //console.log(this.sectionarry[i].sectionName);
       if(sectionval==this.sectionarry[i].sectionName){
        this.quescount=this.sectionarry[i].noofQuestion;
       }
     }
     for(var k=1;k<=this.quescount;k++){
      this.questionarry.push(k);
     }
    
  }

  /****file uploder responce***/
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  //  console.log("Success");
//    console.log(item); 
    let data = JSON.parse(response); //success server response
    //console.log(data);
      if(data.error==0){
        
        this.uploadimageId=data.result.id;
       
         let objFile = {};
              objFile['filename']=data.result.uploadname;
              objFile['fileId']=data.result.id;
        this.attactmentlist.push(objFile);
       
        if(this.attactmentlist.length>0){
          this.objItemArray.value['file']=objFile;
          this.objItemArray.value['rowindex']=this.rowindex;
          this.sleep(2000).then(() => {
            this.uploader.queue=[];
          })
        }
       
       
        //console.log(this.attactmentlist);
      }
     
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let error = JSON.parse(response); //error server response
      //console.log('file Error');
      //console.log(error);
  }  
  /****file uploder responce***/
  filterarry(arry){
    let newarry=[];
    for(var i in arry){
         if(arry[i]['key']!=undefined){
           newarry.push(arry[i]);
         }
    }
    return newarry;

  }

  filter_array(test_array) {
    var index = -1,
        arr_length = test_array ? test_array.length : 0,
        resIndex = -1,
        result = [];

    while (++index < arr_length) {
        var value = test_array[index];

        if (value) {
            result[++resIndex] = value;
        }
    }

    return result;
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/challenge-forum/challenge-forum.component.ts